<template>
    <transition name="fade" mode="out-in">
        <div>
            <ul class="submenu-sections" v-if="!isLoadingTrack && currentTrack">
                <router-link tag="li" :to="{name:'TrackHome', params:{trackUid:$route.params.trackUid}}">
                    <a><h4><span class="text">Details</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'TrackMix', params:{trackUid:$route.params.trackUid}}">
                    <a><h4><span class="text">Mix Points</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'TrackConstrains', params:{trackUid:$route.params.trackUid}}">
                    <a><h4><span class="text">Constraints</span></h4></a>
                </router-link>
                <router-link tag="li" :to="{name:'TrackBranding', params:{trackUid:$route.params.trackUid}}">
                    <a><h4><span class="text">Branding</span></h4></a>
                </router-link>
              <router-link tag="li" :to="{name:'TrackCharts', params:{trackUid:$route.params.trackUid}}">
                <a><h4><span class="text">Charts</span></h4></a>
              </router-link>
              <router-link tag="li" :to="{name:'TrackLinkBoxes', params:{trackUid:$route.params.trackUid}}">
                <a><h4><span class="text">Link Boxes</span></h4></a>
              </router-link>
            </ul>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { mapState, mapActions } from 'vuex'
    import Translations from '@/store/translations';
    export default {
        name: 'TrackMenu',
        computed: {
            Translations: () => Translations,
            ...mapState("tracks",["currentTrack", "isLoadingTrack"]),
        },
    }
</script>
